import { times } from "lodash-es"
import { ProductCardSkeleton } from "../../../components/ProductCard"
import { ProductList } from "../../../components/ProductList"

export const ProductCategoryProductsSkeleton = ({
  count,
}: {
  count: number
}) => {
  return (
    <ProductList>
      {times(count, (index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </ProductList>
  )
}
